import { render, staticRenderFns } from "./sysDictionaryEdit.vue?vue&type=template&id=0b959354&scoped=true&"
import script from "./sysDictionaryEdit.vue?vue&type=script&lang=js&"
export * from "./sysDictionaryEdit.vue?vue&type=script&lang=js&"
import style0 from "./sysDictionaryEdit.vue?vue&type=style&index=0&id=0b959354&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b959354",
  null
  
)

component.options.__file = "sysDictionaryEdit.vue"
export default component.exports